import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { theme } from '../../theme'
import './index.css'
import * as Styles from './styles'

interface Props {
   logoUrl: string
   logoWidth: number
   title: string
   copyrightsText: string
}

const LaunchingModeUI = (props: Props): React.ReactElement => {
   const { logoUrl, logoWidth, title, copyrightsText } = props

   const t = useCustomT('client:appMode.launchingMode')

   const titleStrings = title.split('\n')

   const themes = theme.launchMode

   const renderBody = () => (
      <div className={Styles.bodyContainerStylesWebView}>
         <img
            alt='Launching Logo'
            src={logoUrl}
            style={{
               width: `${logoWidth}px`,
               marginTop: '92px',
               marginBottom: '100px'
            }}
         />
         {titleStrings.map(title => (
            <p className={cn(Styles.titleStylesWebView, themes.titleTextColor)}>
               {title}
            </p>
         ))}
         <p
            className={cn(
               Styles.descriptionStylesWebView,
               themes.descriptionTextColor
            )}
         >
            {t('launchingSoon')}
         </p>
      </div>
   )

   const renderFooter = () => (
      <p className={cn(Styles.footerTextStylesWebView, themes.footerTextColor)}>
         {copyrightsText}
      </p>
   )

   return (
      <div
         className={cn(Styles.containerStylesWebView, themes.defaultBgColor)}
         style={{
            backgroundImage: "url('./assets/clientImages/launch_mode_bg.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center bottom 15px'
         }}
      >
         {renderBody()}
         {renderFooter()}
      </div>
   )
}

export default observer(LaunchingModeUI)
